import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse, RoleDto, PermissionDto, CreateRoleRequest, UpdateRolePermissionsRequest } from '../models/models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private readonly apiUrl = `${environment.apiV1Url}/roles`;

  constructor(private http: HttpClient) {}

  getAllRoles(): Observable<ApiResponse<RoleDto[]>> {
    return this.http.get<ApiResponse<RoleDto[]>>(this.apiUrl);
  }

  getAllPermissions(): Observable<ApiResponse<PermissionDto[]>> {
    return this.http.get<ApiResponse<PermissionDto[]>>(`${this.apiUrl}/permissions`);
  }

  createRole(request: CreateRoleRequest): Observable<ApiResponse<RoleDto>> {
    return this.http.post<ApiResponse<RoleDto>>(this.apiUrl, request);
  }

  updateRolePermissions(roleId: string, request: UpdateRolePermissionsRequest): Observable<ApiResponse<RoleDto>> {
    return this.http.put<ApiResponse<RoleDto>>(`${this.apiUrl}/${roleId}/permissions`, request);
  }
}
